/**
 * 全站底部版权相关文案（单一维护入口）
 * 年份使用运行时当前年，避免硬编码过期。
 */

const COPYRIGHT_SUFFIX = "  · AI 语音生成与创作平台";

/** 产品单行版权：认证页、首页、精品译制、CopyrightFooter 等 */
export function buildCopyrightTagline(platformName: string): string {
  const year = new Date().getFullYear();
  return `${year}.${platformName.trim()}${COPYRIGHT_SUFFIX}`;
}

/** 全站 Footer 组件：© 公司名称 */
export function buildFooterCompanyLegal(): string {
  const year = new Date().getFullYear();
  return `© ${year} 媲美科技(长沙)有限公司,保留所有权利`;
}
